"use strict";

console.log("Welcome to the Kazatan Games website :)");

function submitContactForm(event) {
  var formRef = document.getElementById("contact-form");
  var fieldSetRef = document.getElementById("contact-fieldset");
  var nameRef = document.getElementById("name-input");
  var emailRef = document.getElementById("email-input");
  var messageRef = document.getElementById("message-input");
  var recaptchaRef = document.getElementById("recaptcha-input");
  var submitTextRef = document.getElementById("submit-btn-text");
  var loaderRef = document.getElementById("loader");
  var errorRef = document.getElementById("error-message");
  var successRef = document.getElementById("success-message");

  var valid = true;
  if (!nameRef.checkValidity()) {
    nameRef.classList.add("form-control--invalid");
    valid = false;
  } else {
    nameRef.classList.remove("form-control--invalid");
  }
  if (!emailRef.checkValidity()) {
    emailRef.classList.add("form-control--invalid");
    valid = false;
  } else {
    emailRef.classList.remove("form-control--invalid");
  }
  if (!messageRef.checkValidity()) {
    messageRef.classList.add("form-control--invalid");
    valid = false;
  } else {
    messageRef.classList.remove("form-control--invalid");
  }
  if (!grecaptcha.getResponse()) {
    recaptchaRef.classList.add("form-control--invalid");
    valid = false;
  } else {
    recaptchaRef.classList.remove("form-control--invalid");
  }

  if (!valid) {
    return false;
  }


  errorRef.setAttribute("hidden", "hidden");
  fieldSetRef.setAttribute("disabled", "disabled");
  loaderRef.removeAttribute("hidden");
  submitTextRef.setAttribute("hidden", "hidden");

  var xhr = new XMLHttpRequest();
  xhr.addEventListener("load", function() {
    if (xhr.status >= 200 && xhr.status <= 299) {
      var response = JSON.parse(xhr.responseText);
      if (response.success) {
        // success
        formRef.setAttribute("hidden", "hidden");
        successRef.removeAttribute("hidden");
        return;
      }
    }
    // failure
    loaderRef.setAttribute("hidden", "hidden");
    submitTextRef.removeAttribute("hidden");
    fieldSetRef.removeAttribute("disabled");
    errorRef.removeAttribute("hidden");
  });
  xhr.addEventListener("error", function() {
    // failure
    loaderRef.setAttribute("hidden", "hidden");
    submitTextRef.removeAttribute("hidden");
    fieldSetRef.removeAttribute("disabled");
    errorRef.removeAttribute("hidden");
  });
  xhr.open(
    "POST",
    "https://europe-west2-kazatangames-co-uk-2019.cloudfunctions.net/postContactForm",
    true
  );
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(
    JSON.stringify({
      name: nameRef.value,
      email: emailRef.value,
      message: messageRef.value,
      recaptcha: grecaptcha.getResponse()
    })
  );

  console.log("Sent:",
    JSON.stringify({
      name: nameRef.value,
      email: emailRef.value,
      message: messageRef.value
    })
  );

  return false;
}
window.submitContactForm = submitContactForm;
